export default function (context, {field, value}) {
    let data = {}, item;
    switch (field) {
        case 'PaymentOperationID':
            context.commit('set', {PaymentOperationID: value});
            item = context.getters.paymentOperation.filter(i => {
                return i.value === value;
            })[0];
            context.dispatch('change', {field: 'CategoryId', value: item.category});
            context.dispatch('change', {field: 'PaymentTypeId', value: item.type});
            break;
        case 'CategoryId':
            if(context.state.CategoryId!==value&&value!==2){
                context.commit('set', {CategoryId: value});
                context.dispatch('change', {field: 'CashId', value: context.getters.cash[0].value});
                context.dispatch('change', {field: 'PaymentAccountId', value: context.getters.paymentAccount[0].value});
            }
            break;
        default:
            data[field] = value;
    }
    context.commit('set', data);
}